var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"platform"},[_c('banner'),_c('Enablement'),_c('Intelligence'),_c('Demand'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-inner"},[_c('h2',[_vm._v("让世界成为你的市场")]),_c('div',{staticClass:"button-link"},[_vm._v("让我们谈谈")])])])
}]

export { render, staticRenderFns }